import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ReactDOM from 'react-dom'
import { Route } from 'react-router-dom'
import { Link as RouterLink } from 'react-router-dom'
import axios from 'axios'
import T from '../../../SPRINTA/translate/T'
import CoverImage from '../../atoms/CoverImage'
import Valign from '../../atoms/Valign'
import { Container, Row, Col, ResponsiveEmbed, Hidden } from '../../atoms/Grid'
import Font from '../../atoms/Font'
import Avatar from '../../atoms/Avatar'
import Button from '../../atoms/Button'
import V2Button from '../../../SPRINTA/atoms/Button'
import If from '../../atoms/If'
import Rating from '../../atoms/Rating'
import Menu, { Item } from '../../atoms/MenuResponsive'
import BoxAccordion from '../../atoms/BoxAccordion'
import Tag from '../../atoms/Tag'
import FontIcon from '../../atoms/FontIcon'
import SocialShare from '../../atoms/SocialShare'
import FlexAlign from '../../atoms/FlexAlign'
import { PagePoint, ScrollTo, Configure as ConfigureHashLink, GoTo } from '../../atoms/HashLink'
import UploadImage from '../../../SPRINTA/v2/organisms/UploadImages'
import GaleryEvents from '../../../SPRINTA/v2/organisms/GaleryEvents'
import Footer from '../../organisms/Footer'
import PageExtras from './PageExtras'
import { date } from '../../../libraries/Formatter'
import ListPrices from './ListPrices'
import ListCategories from './ListCategories'
import ListImages from './ListImages'
import ListKits from './ListKits'
import ListMaps from './ListMaps'
import ListAttachments from './ListAttachments'
import ListExtras from './ListExtras'
import ListHotel from './ListHotel'
import Athletes from './Athletes'
import Results from '../../molecules-v2/Results'
import ForumEvent from '../../organisms/Discussion'
import Timeline from '../../organisms/Timeline'
import style from './style.css'
import { openModal } from '../../../modules/actions/Modais'
import Select from '../../../v2SPRINTA/atoms/Form/Select'
import Loading from '../../../v2SPRINTA/atoms/Loading'
import Display from '../../../v2SPRINTA/atoms/Display'

import Rewards, { PrizeAccordion } from '../../../pages/event/PrizeAccordion'


import * as Interests from '../../../SPRINTA/utils/interests'
import utm from '../../../libraries/Utm'

class Event extends Component {

    constructor(props) {
        super(props)
        this.state = {
            showDescription: false,
            pagePosition: '',
            topBarFixed: false,
            topBarFixedBox: true,
            athletes: null,
            schedule: null,
            isLoaded: [],
            results: null,
            stages: null,
            resultCategory: null,
            resultFiltered: null,
            disqualified: null,
            hasCategories: false,
            loadindResults: false
        }

        this.timeoutinterest = null

    }

    componentWillMount() {
        this.data = this.props.event.data
        
        if (this.data.kind !== 'event' && this.data.kind !== 'experience') {
            window.location.href = `/404`
        }

        axios.get(`${window.URL_API_EVENT}/event/schedule/find/${this.data.token}`)
        .then(resp => {
            this.setState({
                schedule: resp.result
            })
        })        

        if(this.data.show_list === '1') {

            if(this.data) {
                axios.get(`events/athletes/${this.data.token}/0/4`)
                .then(resp => {
                    this.setState({
                        athletes: resp
                    })
                    if(resp.total > 0) {
                        this.handleIsLoaded('users', true)
                    }
                })

            }
        } else {
            this.setState({
                athletes: []
            })
            this.handleIsLoaded('users', false)
        }

        axios.post(`${window.URL_API}results/event/${this.data.token}`)
        .then(resp => {
            if(resp.length > 0) {
                if(resp.length === 1) {
                    axios.post(`${window.URL_API}results/athletes/${this.data.token}/${resp[0].id}`)
                    .then(data => {
                        if(data) {
                            this.setState({
                                results: data.result
                            })
                        }
                        
                        if(data.disqualified && data.disqualified.length > 0) {
                            this.setState({
                                disqualified: data.disqualified
                            })
                        }

                        let categories = {}
                        data.result.forEach(element => {
                            categories[element['category']] = true
                        });
    
                        let filteredCategories = Object.keys(categories);
                        if(Object.keys(filteredCategories).length > 1){
                            this.setState({
                                resultCategory: filteredCategories,
                                hasCategories: true
                            })
                        } else {
                            this.setState({
                                hasCategories: false
                            })
                        }
                    })
                } else {
                    this.setState({
                        stages: resp
                    })
                }

                this.handleIsLoaded('results', true)
            }
        })

        if(this.props.isLogged && this.data.opened === 1 && this.data.kind === 'event') {
            this.timeoutinterest = window.setTimeout(() => {
                Interests.create(this.data.kind, this.data.id)
            }, 5000)
        }

        ConfigureHashLink(200)

        utm.capture({
            origin: 'event',
            token: this.data.token,
        })
    }


    componentDidMount() {
        var element = document.documentElement || document.body
        let topDistance = this.data.points < 70 ? 290 : 600

        function findPosY(obj) {
            var curtop = 0
            if (obj.offsetParent) {
                while (obj.offsetParent) {
                    curtop += obj.offsetTop
                    obj = obj.offsetParent
                }
            } else if (obj.y)
                curtop += obj.y

            return curtop
        }

        this.scroll = function() {
            if(element.clientWidth < 1100 && this.state.topBarFixed === true) {
                this.setState({
                    topBarFixed: false
                })
                return
            } else if(element.clientWidth < 1100) return


            if(element.scrollTop > topDistance && this.state.topBarFixed === false) {
                this.setState({
                    topBarFixed: true
                })
                return
            }
            if( element.scrollTop < topDistance && this.state.topBarFixed === true) {
                this.setState({
                    topBarFixed: false
                })
                return
            }

            let timeline = ReactDOM.findDOMNode(this.refs.timeline)
            let stopTopDistance = findPosY(timeline) - 400

            if(stopTopDistance < element.scrollTop && this.state.topBarFixedBox === true) {
                this.setState({
                    topBarFixedBox: false
                })
            } else if( stopTopDistance > element.scrollTop && this.state.topBarFixedBox === false ) {
                this.setState({
                    topBarFixedBox: true
                })
            }

        }.bind(this)

        window.addEventListener('scroll', this.scroll)

        
        if(this.data.owner_id == 30553){
            console.log('carrega Brasil Ride')
            window.fbq('init', '1564726501088368')
            window.fbq('track', 'PageView')
            window.gtag('config', 'AW-629127483')
            window.gtag('config', 'UA-34507470-2')
            window.gtag('config', 'G-BCCHBF5EGF')
            window.gtag('config', 'GTM-W3R8M6KB')
                 


        }

            
            
        
        
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.scroll)
        clearTimeout(this.timeoutinterest)
    }

    positionPage(name) {
        if(this.state.pagePosition !== name)
        this.setState({
            pagePosition: name
        })
    }

    smoothScrollTo (endX, endY, duration) {
        const startX = window.scrollX || window.pageXOffset
        const startY = window.scrollY || window.pageYOffset
        const distanceX = endX - startX
        const distanceY = endY - startY
        const startTime = new Date().getTime()
      
        duration = typeof duration !== 'undefined' ? duration : 400
      
        const easeInOutQuart = (time, from, distance, duration) => {
            let timeDuration = (time /= duration / 2)
            if (timeDuration < 1) return distance / 2 * time * time * time * time + from
            return -distance / 2 * ((time -= 2) * time * time * time - 2) + from
        };
      
        const timer = setInterval(() => {
            const time = new Date().getTime() - startTime;
            const newX = easeInOutQuart(time, startX, distanceX, duration)
            const newY = easeInOutQuart(time, startY, distanceY, duration)
            
            if (time >= duration) {
                clearInterval(timer)
            }

            window.scroll(newX, newY)

        }, 1000 / 60)
    }

    handleIsLoaded(box, isLoaded) {

        if(!isLoaded) return

        let loaded = this.state.isLoaded

        loaded[box] = true

        this.setState({
            isLoaded: loaded
        })
    }

    setCategory(id) {

        this.setState({
            resultCategory: null,
            resultFiltered: null,
            disqualified: null,
            loadindResults: true
        })

        if(id !== '0') {
            axios.post(`${window.URL_API}/results/athletes/${this.data.token}/${id}`)
            .then(resp => {
                if(resp) {
                    this.setState({
                        results: resp.result
                    })

                    if(resp.disqualified && resp.disqualified.length > 0) {
                        this.setState({
                            disqualified: resp.disqualified
                        })
                    }

                    let categories = {}
                    resp.result.forEach(element => {
                        categories[element['category']] = true
                    });

                    let filteredCategories = Object.keys(categories);

                    if(Object.keys(filteredCategories).length > 1){
                        this.setState({
                            resultCategory: filteredCategories,
                            hasCategories: true,
                            loadindResults: false
                        })
                    } else {
                        this.setState({
                            hasCategories: false,
                            resultFiltered: resp.result,
                            loadindResults: false
                        })
                    }
                }
            })
        } else {
            this.setState({
                resultCategory: null,
                resultFiltered: null,
                disqualified: null,
                loadindResults: false
            })
        }
    }

    setResults(category) {
        
        if(category === 'overall') {
            this.setState({
                resultFiltered: this.state.results
            })
        } else if(category !== '0') {
            let resultFiltered = this.state.results.filter(athletes => {
                return athletes.category === category
            })
            this.setState({
                resultFiltered: resultFiltered
            })
        } else {
            this.setState({
                resultFiltered: null,
                disqualified: null,
                loadindResults: false
            })
        }
    }

    render() {
        if(!this.data) return null

        setTimeout(() => {
            let hash = window.location.hash.replace('#', '')
            if(hash !== '') {
                window.history.pushState("", document.title, window.location.pathname
                + window.location.search)
                GoTo(hash)
            }
        }, 100)

        //correcão de link do youtube
        if( this.data.video_embed ) {
            var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            var match = this.data.video_embed.match(regExp);
            if (match && match[2].length === 11)
                this.data.video_embed = 'https://www.youtube.com/embed/' + match[2]
        }

        return (
            <div stlye={{position: 'relative'}}>
                <CoverImage className={`${(this.state.topBarFixed) ? style.topFixed : style.topNonFixed}`} image={`${this.data.cover_path}`} shadow={this.data.points >= 70 ? 300 : 600}>
                    {!this.state.topBarFixed && (
                        <Container>
                            <Row>
                                <Valign height={this.data.points >= 70 ? '600px' : '290px'}>
                                    <Col size='9'>
                                        {this.data.difficulty && this.data.difficulty !== "0" && (
                                            <Rating label={this.data.points >= 70 ? T.txt('experience') : T.txt('difficulty')} exp={parseInt(this.data.difficulty, 10)} />
                                        )}
                                        <div className={style.titleEvent}>{this.data.title}</div>
                                        {/* <div><Tag color="grey">  Pacotes de viagem</Tag></div> */}
                                    
                                    </Col>
                                    <Col style={{marginTop: '15px'}}>
                                        {/* <If test={this.data.opened}>
                                            <div className={style.boxHeader} style={{position:'relative', top: '-10px'}}>
                                                <Button color='transparent-white' inline onClick={this.props.handleSignup || null}>
                                                    { this.data.inscription.inscription_status === "finished" ? T.text('my_inscription') : T.text('inscription') }

                                                </Button>
                                            </div>
                                        </If>
                                        <If test={!this.data.opened}> */}
                                            <div className={style.boxHeader} style={{position:'relative', top: '-10px'}}>
                                                {this.inscriptionButton('cover')}
                                            </div>
                                        {/* </If> */}
                                        <div className={style.boxHeader}>
                                            <Font size='14' color='#fff'>{T.text('event_start')}</Font> <br />
                                            <Font size='20' color='#fff' weight='bold'>{date(this.data.date).br}</Font>
                                        </div>
                                        <div className={style.boxHeader}>
                                            <Font size='14' color='#fff'>{T.text('event_time')}</Font> <br />
                                            <Font size='20' color='#fff' weight='bold'>{this.data.hour}</Font>
                                            
                                        </div>
                                        <div className={style.boxHeader}>
                                            <Font size='14' color='#fff'>{T.text('event_location')}</Font> <br />
                                            <Font size='20' color='#fff' weight='bold'>{this.data.city} ({this.data.state_abbreviation})</Font>
                                        </div>
                                    </Col>
                                </Valign>
                            </Row>
                        </Container>

                    )}
                    {this.state.topBarFixed && (
                        <div className={style.description}>
                            <Container>
                                <Row>
                                    <Col>
                                        <Font heading='1' size='20' color='#fff'>{this.data.title}</Font>
                                        <Font size={12} color='#fff'>{date(this.data.date).br} | {this.data.city} ({this.data.state_abbreviation})</Font>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    )}

                </CoverImage>
                <div className={`${style.barMenu} ${(this.state.topBarFixed) ? style.barFixed : ''}`}>
                    <Container>
                        <Row>
                            <Col size='8'>
                                <Row>
                                    <Route exact path="/(event|experience|e)/:token" render={() => (
                                        <Menu>
                                            <ScrollTo location='about'>
                                                <Item active={this.state.pagePosition === 'about' ? true : false}>{T.text('about')}</Item>
                                            </ScrollTo>
                                            
                                            { this.state.isLoaded['results'] && (
                                                <ScrollTo location='results'>
                                                    <Item active={this.state.pagePosition === 'results' ? true : false}>{T.text('results')}</Item>
                                                </ScrollTo>
                                            )}

                                            { this.state.isLoaded['images'] && (
                                                <ScrollTo location='images'>
                                                    <Item active={this.state.pagePosition === 'images' ? true : false}>{T.text('photos')}</Item>
                                                </ScrollTo>
                                            )}
                                            { this.state.isLoaded['categories'] && (
                                                <ScrollTo location='categories'>
                                                    <Item active={this.state.pagePosition === 'categories' ? true : false}>{T.text('categories')}</Item>
                                                </ScrollTo>
                                            )}

                                            { this.data.has_extra_hotels === '1' && (
                                                <ScrollTo location='hotel'>
                                                    <Item active={this.state.pagePosition === 'hotel' ? true : false}>{T.text('accommodation')}</Item>
                                                </ScrollTo>
                                            )}

                                            { this.state.isLoaded['users'] && (
                                                <ScrollTo location='users'>
                                                    <Item active={this.state.pagePosition === 'users' ? true : false}>{T.text('enrolled')}</Item>
                                                </ScrollTo>
                                            )}

                                            {this.data.talk_to_organizer === '1' && (
                                                <ScrollTo location='faq'>
                                                    <Item active={this.state.pagePosition === 'faq' ? true : false}>{T.text('faq')}</Item>
                                                </ScrollTo>
                                            )}

                                            { this.state.isLoaded['news'] && (
                                                <ScrollTo location='news'>
                                                    <Item active={this.state.pagePosition === 'news' ? true : false}>{T.text('news')}</Item>
                                                </ScrollTo>
                                            )}

                                            {this.data.allow_extra_sales === '1'&& (

                                                <RouterLink to={`/event/${this.data.token}/extras`} onClick={() => {
                                                    this.setState({
                                                        pagePosition: 'extras'
                                                    })
                                                }}>
                                                    <Item active={false}>{T.text('items_extras')}</Item>
                                                </RouterLink>
                                            )}
                                        </Menu>
                                    )} />
                                    <Route exact path="/(event|experience|e)/:token/extras" render={() => (
                                        <Menu>

                                            <RouterLink to={`/event/${this.data.token}#about`}>
                                                <Item active={this.state.pagePosition === 'about' ? true : false}>{T.text('about')}</Item>
                                            </RouterLink>
                                            { this.state.isLoaded['images'] && (
                                                <RouterLink to={`/event/${this.data.token}#images`}>
                                                    <Item active={this.state.pagePosition === 'images' ? true : false}>{T.text('photos')}</Item>
                                                </RouterLink>
                                            )}
                                            { this.state.isLoaded['categories'] && (
                                                <RouterLink to={`/event/${this.data.token}#categories`}>
                                                    <Item active={this.state.pagePosition === 'categories' ? true : false}>{T.text('categories')}</Item>
                                                </RouterLink>
                                            )}

                                            { this.data.has_extra_hotels === '1' && (
                                                <RouterLink to={`/event/${this.data.token}#hotel`}>
                                                    <Item active={this.state.pagePosition === 'hotel' ? true : false}>{T.text('accommodation')}</Item>
                                                </RouterLink>
                                            )}

                                            { this.state.isLoaded['users'] && (
                                                <RouterLink to={`/event/${this.data.token}#users`}>
                                                    <Item active={this.state.pagePosition === 'users' ? true : false}>{T.text('enrolled')}</Item>
                                                </RouterLink>
                                            )}
                                            <RouterLink to={`/event/${this.data.token}#faq`}>
                                                <Item active={this.state.pagePosition === 'faq' ? true : false}>{T.text('faq')}</Item>
                                            </RouterLink>

                                            { this.state.isLoaded['news'] && (
                                                <RouterLink to={`/event/${this.data.token}#news`}>
                                                    <Item active={this.state.pagePosition === 'news' ? true : false}>{T.text('news')}</Item>
                                                </RouterLink>
                                            )}

                                            <Item active={true}>{T.text('items_extras')}</Item>
                                        </Menu>
                                    )} />
                                </Row>
                            </Col>
                            <Col size='4' className={style.inscriptionBar} style={{ cursor: !this.data.opened && (new Date(this.data.date).getTime() < new Date().getTime()) ? 'default' : 'pointer' }}>
                                <Font color='#ffffff' size='15' weight='800' onClick={() => !this.data.opened && (new Date(this.data.date).getTime() < new Date().getTime()) ? null : this.props.handleSignup("uniq")}>
                                    {T.text(!this.data.opened && (new Date(this.data.date).getTime() < new Date().getTime()) ?  'share_your_pictures' : 'inscription')}
                                </Font>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <Container className={`${(this.state.topBarFixed) ? style.spacerTopBar : ''}`}>
                    <Row>
                        <Col size='4' float='right' style={{position: 'static', borderLeft: '1px solid transparent'}}>
                            <div className={`${(this.state.topBarFixed) ? style.boxRightFixed : ''}`} style={{ display: (this.state.topBarFixedBox) ? 'block' : 'none', marginLeft: '-1px' }}>
                                <Row>
                                    {!this.data.opened && (new Date(this.data.date).getTime() < new Date().getTime()) ? (    
                                        <UploadImage token={this.data.token} kind={this.data.kind} handleSignup={ () => this.props.openModal('modal-login') } logged={this.props.isLogged} />
                                    ) : (
                                        <Hidden sm style={{width:'100%'}}>
                                            <Col className={style.boxOrange}>
                                                <Col float='center' size='10'>
                                                    <If test={this.data.type === 'free'}>
                                                        {T.text('free_inscription')}
                                                    </If>
                                                    <div className={style.btns}>
                                                        {this.inscriptionButton('box')}
                                                    </div>
                                                    <If test={this.data.opened && this.data.allow_other === "1"}>
                                                        <div className={style.btns}>
                                                            <Button color='transparent-white' onClick={()=>this.props.handleSignup('other')}>{T.text('enroll_a_friend')}</Button>
                                                        </div>
                                                    </If>

                                                </Col>
                                            </Col>
                                        </Hidden> 
                                    )}

                                    <Col className={style.share}>
                                        <Col size={12} float='center'>
                                            <span className={style.text}>{T.text('share')}</span>
                                            <span className={style.socialitem}>
                                                <SocialShare type='Facebook'><FontIcon size={30} name='facebook'/></SocialShare>
                                            </span>
                                            <span className={style.socialitem}>
                                                <SocialShare type='Twitter'><FontIcon size={30} name='twitter'/></SocialShare>
                                            </span>
                                        </Col>
                                    </Col>
                                </Row>
                            </div>
                            {this.state.topBarFixed && (
                                <div className={style.spacerRight} style={{ height: this.data.points >= 70 ? '490px' : '235px'}}><br/></div>
                            )}

                            {
                                ( this.data.have_kits === '1' ||
                                this.data.has_emergency_room === '1' ||
                                this.data.has_awards === '1' ||
                                this.data.has_a_shirt === '1' ||
                                this.data.has_bathrooms === '1' ||
                                this.data.have_insurance === '1' ||
                                this.data.has_storage_volumes === '1' ||
                                this.data.has_accommodation === '1' ||
                                this.data.has_hydration === '1' ||
                                this.data.has_lunch === '1' ||
                                this.data.has_locker_rooms === '1' )
                                && (

                                <Row style={{marginTop: "20px", marginBottom: "20px"}}>
                                    <Col style={{marginBottom: '10px'}}>
                                        <Col>
                                            <Font size='25' color='#4a4a4a'>{T.text('headline_included_in_event')}</Font>
                                        </Col>
                                    </Col>
                                    <Col>
                                        <If test={this.data.have_kits === '1'}>
                                            <Tag> <FontIcon name='kit' /> {T.text('event_have_kit')}</Tag>
                                        </If>
                                        <If test={this.data.has_emergency_room === '1'}>
                                            <Tag> <FontIcon name='hospital' /> {T.text('event_has_emergency_room')}</Tag>
                                        </If>
                                        <If test={this.data.has_awards === '1'}>
                                            <Tag> <FontIcon name='prize' /> {T.text('event_has_awards')}</Tag>
                                        </If>
                                        <If test={this.data.has_a_shirt === '1'}>
                                            <Tag> <FontIcon name='shirt' /> {T.text('event_has_a_shirt')}</Tag>
                                        </If>
                                        <If test={this.data.has_bathrooms === '1'}>
                                            <Tag> <FontIcon name='wc' /> {T.text('event_has_bathrooms')}</Tag>
                                        </If>
                                        <If test={this.data.have_insurance === '1'}>
                                            <Tag> <FontIcon name='insurance' /> {T.text('event_have_insurance')}</Tag>
                                        </If>
                                        <If test={this.data.has_storage_volumes === '1'}>
                                            <Tag> <FontIcon name='lock' /> {T.text('event_has_storage_volumes')}</Tag>
                                        </If>
                                        <If test={this.data.has_accommodation === '1'}>
                                            <Tag> <FontIcon name='bed' /> {T.text('event_has_accommodation')}</Tag>
                                        </If>
                                        <If test={this.data.has_hydration === '1'}>
                                            <Tag> <FontIcon name='water' /> {T.text('event_hydration')}</Tag>
                                        </If>
                                        <If test={this.data.has_lunch === '1'}>
                                            <Tag> <FontIcon name='food' /> {T.text('event_has_lunch')}</Tag>
                                        </If>
                                        <If test={this.data.has_locker_rooms === '1'}>
                                            <Tag> <FontIcon name='shower' /> {T.text('event_has_locker_rooms')}</Tag>
                                        </If>
                                    </Col>
                                </Row>
                            )}


                            <Col style={{marginTop: "20px", marginBottom: "20px"}}>
                                <Col style={{marginBottom: '30px'}}>
                                    <Row>
                                        <Font size='25' color='#4a4a4a'>{T.text('headline_event_organizer')}</Font>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row>
                                        <FlexAlign>
                                            <div style={{textAlign:'center', width: '115px', position: 'relative'}}>
                                                <Avatar size={100} img={this.data.user_avatar_path}/>
                                                <div className={style.iconCheck}>
                                                    <FontIcon name='check-o'/>
                                                </div>
                                            </div>
                                            <div>
                                                <Font size='20' weight='bold' color='#666' style={{marginBottom: '10px'}}>
                                                    {this.data.user_name}
                                                </Font>
                                                <br />
                                                <a href={`${window.config.url_base_old}${this.data.user_uri}`}>
                                                    <Button inline color='transparent-grey'>
                                                        {T.text('goto_profile')}
                                                    </Button>
                                                </a>
                                            </div>
                                        </FlexAlign>
                                    </Row>
                                </Col>
                            </Col>
                        </Col>

                        <Col size='8' float='right'>
                            <Route exact path="/(event|experience|e)/:token" render={() => (
                                <React.Fragment>
                                    {this.state.topBarFixed && (
                                        <div style={{ height: this.data.points >= 70 ? '320px' : '0px'}}><br/></div>
                                    )}
                                    <Row>
                                        <PagePoint name={'about'} handleOn={(name) => this.positionPage(name) }>

                                            <Col style={{marginBottom: '30px', marginTop: '20px'}}>
                                                {!this.data.opened && (new Date(this.data.date).getTime() <= new Date().getTime()) ? (
                                                    <GaleryEvents token={this.data.token} kind={this.data.kind} limit={36} />
                                                ) : (
                                                    <React.Fragment>
                                                        <div style={{marginTop: '40px', marginBottom: '20px'}}>
                                                            
                                                            <PrizeAccordion id={this.data.id}/>
                                                        </div>
                                                        
                                                        <div style={{marginTop: '40px', marginBottom: '20px'}}>
                                                            <Font size='30' color='#4a4a4a' weight='100'>{this.data.title}</Font>
                                                        </div>
                                                        
                                                        <div className={style.description}>
                                                            <BoxAccordion style={{marginBottom: '20px', color: '#4a4a4a', fontSize: '14px'}} height='500px' show={this.state.showDescription}>
                                                                <div style={{marginBottom: this.state.schedule ? '14px' : ''}}dangerouslySetInnerHTML={{__html: this.data.description}} />
                                                                {this.state.schedule && (
                                                                    T.text('schedule')
                                                                )}
                                                                {this.state.schedule && (
                                                                    Object.keys(this.state.schedule).map((key) => {
                                                                        let item = this.state.schedule[key]
                                                                        let month = date(key).month('br')
                                                                        let weekDay = date(key).day()
                                                                        return (
                                                                            <Row key={key}>
                                                                                <Col size={12}>
                                                                                    <p><b>{weekDay.str} - {weekDay.int} de {month.str}</b></p>
                                                                                </Col>
                                                                                {item.map(el => (
                                                                                    <Col key={el.id} size={12}>
                                                                                        <Col>
                                                                                            <b>•</b> {el.time}{el.finishTime ? ` às ${el.finishTime}` : ''} - {el.description}
                                                                                        </Col>
                                                                                    </Col> 
                                                                                ))}
                                                                            </Row>
                                                                        )
                                                                    })    
                                                                )}
                                                            </BoxAccordion>
                                                        </div>
                                                        <If test={!this.state.showDescription}>
                                                            <V2Button
                                                                inline
                                                                theme='secondary'
                                                                onClick={
                                                                    () => {
                                                                        this.setState({
                                                                            showDescription: true
                                                                        })
                                                                    }
                                                                }
                                                            >
                                                                {T.text('see_more')}
                                                            </V2Button>
                                                        </If>

                                                        <If test={this.state.showDescription}>
                                                            <V2Button
                                                                inline
                                                                theme='secondary'
                                                                onClick={
                                                                    () => {
                                                                        this.smoothScrollTo (60, 0)
                                                                        this.setState({
                                                                            showDescription: false
                                                                        })
                                                                    }
                                                                }
                                                            >
                                                            {T.txt('see_less')}
                                                            </V2Button>
                                                        </If>
                                                    </React.Fragment>
                                                )}
                                            </Col>

                                        </PagePoint>
                                        { this.state.isLoaded['results'] && (
                                            <PagePoint name={'results'} handleOn={(name) => this.positionPage(name) }>
                                                <Col size='12'>
                                                    <Display style={{color: '#000', marginBottom: '30px', display: 'block', fontSize: '30px'}} size='2'>{T.txt('results')}</Display>
                                                    {this.state.stages && (
                                                        <Fragment>
                                                            <Row>
                                                                <Col size='4'>
                                                                    <Select transparent onChange={(e) => this.setCategory(e.target.value)} style={{marginBottom: '30px'}} label={T.txt('stage')}>
                                                                        <option value='0'>Selecione</option>
                                                                        {this.state.stages.map(stage => {
                                                                            return (
                                                                                <option key={stage.id} value={stage.id}>{stage.title}</option>
                                                                            )
                                                                        })}
                                                                    </Select>
                                                                </Col>
                                                                {this.state.resultCategory && this.state.hasCategories && (
                                                                    <Col size='4'>
                                                                        <Select transparent onChange={(e) => this.setResults(e.target.value)} style={{marginBottom: '60px'}} label={T.txt('categories')}>
                                                                            <option value='0'>Selecione</option>
                                                                            <option value='overall'>Geral</option>
                                                                            {this.state.resultCategory.map(item => {
                                                                                return (
                                                                                    <option key={`key__${item}`} value={item}>{item}</option>
                                                                                )
                                                                            })}
                                                                        </Select>
                                                                    </Col>
                                                                )}
                                                                {this.state.loadindResults && (
                                                                    <Col size='2'>
                                                                        <Loading style={{position: 'relative', top: '5px'}}/>
                                                                    </Col>
                                                                )}
                                                            </Row>
                                                            {this.state.resultFiltered && (
                                                                <Results disqualified={this.state.disqualified ? this.state.disqualified : null} results={this.state.resultFiltered}/>
                                                            )}
                                                        </Fragment>
                                                    )}
                                                    { this.state.results && !this.state.stages && (
                                                        <Fragment>
                                                            {this.state.resultCategory && this.state.hasCategories ? (
                                                                <Fragment>
                                                                    <Row>
                                                                        <Col size='4'>
                                                                            <Select transparent onChange={(e) => this.setResults(e.target.value)} style={{marginBottom: '60px'}} label={T.txt('categories')}>
                                                                                <option value='0'>Selecione</option>
                                                                                <option value='overall'>Geral</option>
                                                                                {this.state.resultCategory.map(item => {
                                                                                    return (
                                                                                        <option key={`key__${item}`} value={item}>{item}</option>
                                                                                    )
                                                                                })}
                                                                            </Select>
                                                                        </Col>
                                                                        {this.state.loadindResults && (
                                                                            <Col size='2'>
                                                                                <Loading style={{position: 'relative', top: '5px'}}/>
                                                                            </Col>
                                                                        )}
                                                                    </Row>
                                                                    {this.state.resultFiltered && (
                                                                        <Results disqualified={this.state.disqualified ? this.state.disqualified : null} results={this.state.resultFiltered}/>
                                                                    )}
                                                                </Fragment>
                                                            ) : (
                                                                <Results disqualified={this.state.disqualified ? this.state.disqualified : null} results={this.state.results}/>
                                                            )}

                                                        </Fragment>
                                                    )}
                                                </Col>
                                            </PagePoint>
                                        )}
                                    </Row>
                                    {new Date(this.data.date).getTime() > new Date().getTime() ? (
                                        <React.Fragment>
                                            <If test={this.data.video_embed}>
                                                <Row>
                                                    <Col>
                                                        <div style={{marginBottom: '30px', marginTop: '30px'}}>
                                                            <ResponsiveEmbed>
                                                                <iframe title='video-event' width="853" height="380" src={this.data.video_embed} frameBorder="0" allowFullScreen />
                                                            </ResponsiveEmbed>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </If>

                                            <PagePoint name={'images'} handleOn={(name) => this.positionPage(name) }>
                                                <ListImages token={this.data.token} handleLoaded={ (haveContent) => this.handleIsLoaded('images', haveContent) }/>
                                            </PagePoint>


                                                <ListKits token={this.data.token} />

                                                <ListMaps token={this.data.token} />


                                            <PagePoint name={'categories'} handleOn={(name) => this.positionPage(name) }>
                                                <ListCategories token={this.data.token} handleLoaded={ (haveContent) => this.handleIsLoaded('categories', haveContent) }/>
                                            </PagePoint>
                                        </React.Fragment>
                                    ) : null}
                                </React.Fragment>
                            )} />
                            
                            <Route exact path="/(event|experience|e)/:token/extras" render={() => (
                                <div>
                                    {this.state.topBarFixed && (
                                        <div style={{ height: this.data.points >= 70 ? '320px' : '0px'}}><br/></div>
                                    )}
                                    <PageExtras token={this.data.token} />
                                </div>
                            )} />
                            

                        </Col>
                    </Row>
                </Container>



                {/* {(new Date(this.data.date).getTime() > new Date().getTime()) ? ( */}
                    <Route exact path="/(event|experience|e)/:token" render={() => (
                        <div>
                            {/* {console.log(new Date(this.data.date+' '+this.data.hour).getTime())}
                            {console.log(new Date(this.data.date).getTime())} */}

                            { this.data.type === 'paid' && (
                                <ListPrices token={this.data.token}/>
                            ) }

                                
                            { this.data.has_extra_hotels === '1' && (
                                <div>
                                    <PagePoint name={'hotel'} handleOn={(name) => this.positionPage(name) } />
                                    <ListHotel token={this.data.token}/>                        
                                </div>
                            )}
                            
                            <ListExtras token={this.data.token}/>
                            <ListAttachments token={this.data.token}/>

                            <PagePoint name={'users'} handleOn={(name) => this.positionPage(name) } style={{marginBottom: '30px'}}>
                                {this.state.athletes && this.state.athletes.total > 0 && (
                                    <div className={style.bgGrey}>
                                        <Container>
                                            <Row>
                                                <Col size={8}>
                                                    <Row>
                                                        <Col size={3} style={{marginTop: '25px'}} className={`${style.title} ${style.enrolled}`}>
                                                            {T.text('athletes_enrolled')}
                                                        </Col>
                                                        <Col size={9}>
                                                            <Athletes token={this.data.token} data={this.state.athletes}/>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                )}
                            </PagePoint>

                        </div>
                    )} />
                {/* ) : null} */}
                
                {this.data.talk_to_organizer === '1' && (
                    <PagePoint name={'faq'} handleOn={(name) => this.positionPage(name) }>
                        <Container ref="forum" style={{paddingBottom: '60px'}}>
                            <Row>
                                <Col size={8}>
                                    <div className={style.title}>{T.text('faq_title')}</div>

                                    <Font style={{marginBottom:'20px'}} color='#4a4a4a'>{T.text('faq_headline')}</Font>
                                    <br />
                                    <ForumEvent data={{...this.data, type: 'event'}} />
                                </Col>
                            </Row>
                        </Container>
                    </PagePoint>
                )}

                <PagePoint name={'news'} handleOn={(name) => this.positionPage(name) }>
                    <div style={{float: 'left', width: '100%', backgroundColor: '#f9f9f9', padding: '50px 0', borderBottom: '1px solid #9d9797'}}>
                        <Container ref='timeline'>
                            <Route exact path="/(event|experience|e)/:token" render={() => (
                                <Timeline handleLoaded={(haveContent) => this.handleIsLoaded('news', haveContent)} title={T.txt('headline_event_timeline')} type='event' id={this.data.token}/>
                            )} />
                        </Container>
                    </div>
                </PagePoint>
                
                <Footer />
            </div>
        )
    }

    inscriptionButton(type) {
        return (
            <span>
                <If test={this.data.inscription.inscription_status}>
                    <If test={this.data.inscription.inscription_status !== 'confirmed' && this.data.close_to_pay !== '1'}>
                        <V2Button onClick={this.props.handleSignup || null} theme='dark'>{T.txt("see_my_inscription")}</V2Button>
                    </If>
                    <If test={this.data.inscription.inscription_status === 'confirmed'}>
                        <V2Button onClick={this.props.handleSignup || null} theme='dark' disabled>{T.txt("see_my_inscription")}</V2Button>
                    </If>
                </If>

                <If test={!this.data.inscription.inscription_status && this.data.opened && this.data.close_to_pay !== '1'}>
                    <V2Button theme={`${type === 'cover' ? 'primary' : 'dark'}`} onClick={()=>this.props.handleSignup('other')}>
                        { this.data.inscription.inscription_status === "finished" ? T.text('my_inscription') : this.data.btn_action ? this.data.btn_action : T.text('i_want_to_sign_up') }
                    </V2Button>
                </If>

                <If test={(!this.data.opened
                            && !this.data.inscription.inscription_status)

                            || (
                                this.data.inscription.inscription_status !== 'confirmed'
                                && this.data.close_to_pay === '1'
                            )
                        }>

                    {this.data.situation === 'open' ? (
                        <V2Button theme='dark' disabled>{T.text('closed_inscriptions')}</V2Button>
                    ) : (
                        <V2Button theme='dark' disabled>{T.text('comming_soon')}</V2Button>
                    )}
                </If>
            </span>
        )
    }

}

const mapStateToProps = state => ({
    store: state
})

const mapDispatchToProps = dispatch => bindActionCreators({
    openModal
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Event)


// WEBPACK FOOTER //
// ./src/components/templates/Event/index.js